import { render } from "./status-notification.vue?vue&type=template&id=5ae66564&scoped=true"
import script from "./status-notification.vue?vue&type=script&lang=js"
export * from "./status-notification.vue?vue&type=script&lang=js"

import "./status-notification.vue?vue&type=style&index=0&id=5ae66564&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae66564"]])

export default __exports__